import {CLAIMS_PRACTICE} from './claims/claims-commons/claims-commons-routing-roots';

export const ROOT_PROFILE_MANAGER: string = 'profile-manager';
export const ROOT_DELIVERY: string = 'delivery';
export const ROOT_DELIVERY_ASR: string = ROOT_DELIVERY + '-asr';
export const ROOT_CHANGE_CENTER_DELIVERY: string = 'Cambia centro';
export const ROOT_ERROR_PAGE: string = 'error-page';
export const ROOT_NOT_FOUND_PAGE: string = 'not-found-page';
export const ROOT_DIGITAL_SIGN: string = 'digital-sign';
export const ROOT_REDIRECT: string = 'redirect';
export const ROOT_PROFILE: string = 'profile';
export const ROOT_CONTRACT_CLOSING: string = 'contract-closing';
export const ROOT_NOTIFICATION_CENTER: string = 'notification-center';
export const CONTRACT_CLOSING_ALD: string = 'ald';
export const ROOT_CONTRACT_CLOSING_ALD: string = ROOT_CONTRACT_CLOSING + '/' + CONTRACT_CLOSING_ALD;
export const CONTRACT_CLOSING_DKC: string = 'dkc';
export const ROOT_CONTRACT_CLOSING_DK_C: string = ROOT_CONTRACT_CLOSING + '/' + CONTRACT_CLOSING_DKC;
export const CONTRACT_CLOSING_DKO: string = 'dko';
export const ROOT_CONTRACT_CLOSING_DK_OP: string = ROOT_CONTRACT_CLOSING + '/' + CONTRACT_CLOSING_DKO;
export const CONTRACT_CLOSING_SP: string = 'sp';
export const ROOT_CONTRACT_CLOSING_SP: string = ROOT_CONTRACT_CLOSING + '/' + CONTRACT_CLOSING_SP;
export const CONTRACT_CLOSING_BO: string = 'bo';
export const ROOT_CONTRACT_CLOSING_BO: string = ROOT_CONTRACT_CLOSING + '/' + CONTRACT_CLOSING_BO;
export const ROOT_LOGIN: string = 'login';
export const CONTRACT_CLOSING_DK_BO: string = 'bo';
export const ROOT_CONTRACT_CLOSING_DK_BO: string = ROOT_CONTRACT_CLOSING + '/' + CONTRACT_CLOSING_DK_BO;

export const ROOT_CLAIMS: string = 'claims';
export const CLAIMS_ADMIN: string = 'admin';
export const CLAIMS_DRIVER: string = 'driver';
export const CLAIMS_PUBLIC: string = 'public';
export const CLAIMS_EXTERNAL: string = 'external';
export const CLAIMS_SUPERVISOR: string = 'supervisor';
export const CLAIMS_OLSA: string = 'olsa';
export const CLAIMS_COMPLAINT: string = 'complaint';
export const CLAIMS_REPAIR: string = 'repair';
export const ROOT_CLAIMS_ADMIN: string = ROOT_CLAIMS + '/' + CLAIMS_ADMIN;
export const ROOT_CLAIMS_DRIVER: string = ROOT_CLAIMS + '/' + CLAIMS_DRIVER;
export const ROOT_CLAIMS_PUBLIC: string = ROOT_CLAIMS + '/' + CLAIMS_PUBLIC;
export const ROOT_CLAIMS_EXTERNAL: string = ROOT_CLAIMS + '/' + CLAIMS_EXTERNAL;
export const ROOT_CLAIMS_SUPERVISOR: string = ROOT_CLAIMS + '/' + CLAIMS_SUPERVISOR;
export const ROOT_CLAIMS_OLSA: string = ROOT_CLAIMS + '/' + CLAIMS_OLSA;
export const ROOT_CLAIMS_COMPLAINT: string = ROOT_CLAIMS + '/' + CLAIMS_COMPLAINT;
export const ROOT_CLAIMS_REPAIR: string = ROOT_CLAIMS + '/' + CLAIMS_REPAIR;
export const CLAIMS_APPROPRIATION: string = 'app';
export const CLAIMS_PRACTICE_CAR: string = 'pc';
export const CLAIMS_THEFT: string = 'theft';
export const ROOT_CLAIMS_APPROPRIATION: string = ROOT_CLAIMS + '/' + CLAIMS_APPROPRIATION;
export const ROOT_CLAIMS_PRACTICE_CAR: string = ROOT_CLAIMS + '/' + CLAIMS_PRACTICE_CAR;
export const ROOT_CLAIMS_THEFT: string = ROOT_CLAIMS + '/' + CLAIMS_THEFT;
export const ROOT_CLAIMS_PRACTICES: string = ROOT_CLAIMS + '/' + CLAIMS_PRACTICE;
export const ROOT_AUTHORITY: string = 'authority';
export const ROOT_MOBILITY: string = 'mobility';

export const ROOT_INVOICING: string = 'invoicing';
export const ROOT_TYRES: string = 'tyres';
export const ROOT_USER_CHANGE: string = 'user-change';
  // export const ROOT_USER_CHANGE: string = 'change-user';
export const ROOT_USER_CHANGE_SP: string = ROOT_USER_CHANGE + '/sp';
export const ROOT_USER_CHANGE_ALD: string = ROOT_USER_CHANGE + '/ald';
export const ROOT_USER_CHANGE_ARCHIVED_PROCEDURE: string  = 'archived-procedure';
export const ROOT_VERSION: string = 'version';

export const ROOT_ADMINISTRATION: string = 'administration';
export const ROOT_ADMINISTRATION_SA: string = ROOT_ADMINISTRATION + '/sa';


export const ROOT_LOGISTICS: string = 'logistics';

export const ROOT_CARGOS: string = 'cargos';

export const ROOT_ADMINISTRATION_RULES: string = ROOT_ADMINISTRATION + '/rules';
export const ROOT_ADMINISTRATION_CHANNELING: string = ROOT_ADMINISTRATION + '/channeling';
export const ROOT_ADMINISTRATION_USER_MANAGEMENT: string = ROOT_ADMINISTRATION + '/user-management';
export const ROOT_FLOTTA_POOL: string = 'flotta-pool';
export const ROOT_BOOKINGS: string = 'bookings';
export const ROOT_BOOKINGS_RELIEF: string = ROOT_BOOKINGS + '/relief';
export const ROOT_BOOKINGS_PRELEASE: string = ROOT_BOOKINGS + '/prelease';
export const FIND_CENTERS_DASHBOARD: string = 'find-centers-dashboard';
export const BOOKINGS_RESERVATION_LIST: string = 'reservationlist';
export const CHANGE_CENTERS_DASHBOARD: string = 'Cambia Centro';
